// Utility to build a searchable tasks string small enough for Algolia.
const TASK_FIELDS = ["task", "analyst1", "analyst2", "country", "subject", "dueDate"];
const MAX_LENGTH = 8000;

const toStringSafe = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") return value.trim();
  try {
    return String(value).trim();
  } catch (err) {
    return "";
  }
};

export const buildTasksSearchText = (tasks) => {
  if (!tasks) return "";

  const taskList = Array.isArray(tasks) ? tasks : typeof tasks === "object" ? [tasks] : [];
  if (!taskList.length) return "";

  const perTask = taskList
    .map((task) => {
      if (!task || typeof task !== "object") return "";
      const parts = TASK_FIELDS.map((field) => toStringSafe(task[field])).filter(Boolean);
      return parts.join(" ");
    })
    .filter(Boolean);

  if (!perTask.length) return "";

  const text = perTask.join(" | ");
  return text.length > MAX_LENGTH ? text.slice(0, MAX_LENGTH) : text;
};

export default buildTasksSearchText;
